import type { CSSProperties } from "react";
import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_auth/relations")({
  component: RelationsLayout,
});

function RelationsLayout() {
  const { t } = useTranslation();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const onConsole = pathname.startsWith("/relations/console");
  const onFlow = pathname.startsWith("/relations/flow");
  const onScripts = pathname.startsWith("/relations/scripts");
  const onPriority = pathname.startsWith("/relations/priority");
  const onOwnership = pathname.startsWith("/relations/ownership");
  const onLog = pathname.startsWith("/relations/log");
  const onDeals = pathname.startsWith("/relations/deals");
  const onAttendance = pathname.startsWith("/relations/attendance");
  // Queue is the index route — it's "active" only when no sibling tab is.
  const onQueue =
    !onConsole &&
    !onFlow &&
    !onScripts &&
    !onPriority &&
    !onOwnership &&
    !onLog &&
    !onDeals &&
    !onAttendance;

  return (
    // No fixed height: every tab grows with its content and the page scrolls as
    // one, instead of each tab scrolling inside a box under the tab bar.
    <div style={{ display: "flex", flexDirection: "column", gap: onConsole ? 0 : 16 }}>
      {/* The live console is a full-bleed cockpit — it carries its own header
          and hides the section tabs. */}
      {!onConsole && (
        <div style={tabs}>
          <Link to="/relations" style={{ ...tab, ...(onQueue ? tabOn : {}) }}>
            {t("relations.tab.queue")}
          </Link>
          <Link to="/relations/log" style={{ ...tab, ...(onLog ? tabOn : {}) }}>
            {t("relations.tab.log")}
          </Link>
          <Link to="/relations/deals" style={{ ...tab, ...(onDeals ? tabOn : {}) }}>
            {t("relations.tab.deals")}
          </Link>
          <Link to="/relations/attendance" style={{ ...tab, ...(onAttendance ? tabOn : {}) }}>
            {t("relations.tab.attendance")}
          </Link>
          <Link to="/relations/flow" style={{ ...tab, ...(onFlow ? tabOn : {}) }}>
            {t("relations.tab.flow")}
          </Link>
          <Link to="/relations/scripts" style={{ ...tab, ...(onScripts ? tabOn : {}) }}>
            {t("relations.tab.scripts")}
          </Link>
          <Link to="/relations/priority" style={{ ...tab, ...(onPriority ? tabOn : {}) }}>
            {t("relations.tab.priority")}
          </Link>
          <Link to="/relations/ownership" style={{ ...tab, ...(onOwnership ? tabOn : {}) }}>
            {t("relations.tab.ownership")}
          </Link>
        </div>
      )}
      <div>
        <Outlet />
      </div>
    </div>
  );
}

const tabs: CSSProperties = {
  display: "inline-flex",
  gap: 6,
  padding: 4,
  borderRadius: 18,
  background: "var(--bg-inset)",
  alignSelf: "flex-start",
  maxWidth: "100%",
  // Wraps rather than scrolling sideways: on a 13" laptop the last tabs
  // (Ownership) sat past the edge where nobody could see them.
  flexWrap: "wrap",
  fontSize: 13,
};
const tab: CSSProperties = {
  padding: "5px 16px",
  borderRadius: 999,
  textDecoration: "none",
  color: "var(--fg-mute)",
  border: "1px solid transparent",
  whiteSpace: "nowrap",
};
const tabOn: CSSProperties = {
  background: "var(--bg)",
  color: "var(--fg)",
  border: "1px solid var(--line-soft)",
};
